// extracted by mini-css-extract-plugin
export default {"container":"MyLocation_container__dN4bi","active":"MyLocation_active__8QFnf"};